import { Component, Injector, OnInit } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Observable, of } from "rxjs";
import { map, mergeMap } from 'rxjs/operators';
import moment from "moment";
import Utils from 'src/app/shared/fgi-utils';
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { CanComponentDeactivate } from "src/app/core/can-deactivate-guard.service";
import { JanelaAtualizacaoInformacoes, TIPOS_JANELA } from "src/app/model/janelas-atualizacao-informacoes.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { RemoverAlertasService } from "src/app/shared/services/remover-alertas.service";
import { JanelasAtualizacaoInformacoesService } from "../janelas-atualizacao-informacoes.service";
import { Dominio } from 'src/app/model/dominio-operacao.model';

    
@Component({
    selector: 'app-janelas-atualizaca-info-cadastro',
    templateUrl: './janelas-atualizacao-informacoes-cadastro.html',
    standalone: false
})
export class JanelasAtualizacaoInformacoesCadastroComponent
                extends BaseEntityComponent<JanelaAtualizacaoInformacoes> implements CanComponentDeactivate, OnInit {

    public formJanelaAtualizacaoInfo: UntypedFormGroup;
    public ocorrencias: any[] = [];
    private confirmService: BnConfirmDirective;
    public podeEditar: boolean;
    public dadosDominio: Dominio;

    public tiposJanela = TIPOS_JANELA;
    public podeHabilitarProcessamento: boolean;
    
    constructor(
        private modalService: BnModalMessageService,
        private permissaoService: PermissaoService,
        protected injector: Injector,
        private activatedRoute: ActivatedRoute,
        private janelasAtualizacaoInfoService: JanelasAtualizacaoInformacoesService,
        private removerAlertasService: RemoverAlertasService,
        ) {
        super(janelasAtualizacaoInfoService);
        this.config.rotaLista = "janelas-atualizacao-info/pesquisa";
        this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
    }

    private form(): UntypedFormGroup {
        return this.formBuilder
        .group({
            dataBase:[{
                value: null,
                disabled: !this.modoEdicao},
                Validators.required,
            ],
            
            dataAbertura:[{
                value: null,
                disabled: !this.modoEdicao},
                Validators.required,
            ],

            dataFechamento:[{
                value: null,
                disabled: !this.modoEdicao},
                Validators.required,
            ],  

            dataInicioListagemOperacoes:[{
                value: null,
                disabled: !this.modoEdicao},
                Validators.required,
            ],

            dataFimListagemOperacoes:[{
                value: null,
                disabled: !this.modoEdicao},
                Validators.required,
            ],

            dataUltimaExecucao:[{
                value: null,
                disabled: true}
            ],

            processamentoHabilitado:[{
                value: null,
                disabled: true}
            ],

            ultimaExecucaoRealizadaComSucesso:[{
                value: null,
                disabled: true}
            ],

            tipoJanela:[{
                value: null,
                disabled:!this.modoEdicao},
                Validators.required,
            ],

            modalidadeGarantia:[{
                value: null,
                disabled:!this.modoEdicao},
                Validators.required,
            ]

        },);
    }

    private trataAlteracaoModoEdicao() {
        if (this.modoEdicao) {
            this.formJanelaAtualizacaoInfo.get('dataBase').enable();
            this.formJanelaAtualizacaoInfo.get('dataAbertura').enable();
            this.formJanelaAtualizacaoInfo.get('dataFechamento').enable();
            this.formJanelaAtualizacaoInfo.get('dataInicioListagemOperacoes').enable();
            this.formJanelaAtualizacaoInfo.get('dataFimListagemOperacoes').enable();
            this.formJanelaAtualizacaoInfo.get('tipoJanela').enable();
            this.formJanelaAtualizacaoInfo.get('modalidadeGarantia').enable();
        }
        else {
            this.formJanelaAtualizacaoInfo.get('dataBase').disable();
            this.formJanelaAtualizacaoInfo.get('dataAbertura').disable();
            this.formJanelaAtualizacaoInfo.get('dataFechamento').disable();
            this.formJanelaAtualizacaoInfo.get('dataInicioListagemOperacoes').disable();
            this.formJanelaAtualizacaoInfo.get('dataFimListagemOperacoes').disable();
            this.formJanelaAtualizacaoInfo.get('tipoJanela').disable();
            this.formJanelaAtualizacaoInfo.get('modalidadeGarantia').disable();
        }
    }

    private alteraForm(model: JanelaAtualizacaoInformacoes): void{
        
        this.formJanelaAtualizacaoInfo.patchValue({
            dataBase: this.ajustaCampoDate(model.dataBase),
            dataAbertura: this.ajustaCampoDate(model.dataAbertura),
            dataFechamento: this.ajustaCampoDate(model.dataFechamento),
            dataInicioListagemOperacoes: this.ajustaCampoDate(model.dataInicioListagemOperacoes),
            dataFimListagemOperacoes: this.ajustaCampoDate(model.dataFimListagemOperacoes),
            dataUltimaExecucao: this.ajustaCampoDate(model.dataUltimaExecucao),
            processamentoHabilitado: model.processamentoHabilitado == 'true',
            ultimaExecucaoRealizadaComSucesso: model.ultimaExecucaoRealizadaComSucesso == 'true',
            tipoJanela: model.tipoJanela,
            modalidadeGarantia: model.modalidadeGarantia
        });

    }

    private ajustaCampoDate(data:any): Date {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }
    
        return data;
    }
    
    public ngOnInit(): void{
        this.checaPermissoes();
    }

    private checaPermissoes():void {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
            this.podeEditar = resp && resp[ROLE_GESTOR_ENVIO];
            this.preparaTela().subscribe((obj) => {
                this.janelasAtualizacaoInfoService.getTimeStampISO().subscribe((ts: any) => {
                    const momentoAtual = moment(ts ? 
                      Utils.dataFromISO(ts.nowDateISO) : Utils.dataCorrente()).startOf('day');
                    if (momentoAtual.isAfter(obj.dataFechamento)) {
                        this.podeHabilitarProcessamento = true;
                    }
                    this.setModel(obj);
                    this.alteraForm(this.model);
                    if (!obj.id) {
                        this.editar();
                    }
                });
            });
        });
    }

    private preparaTela(): Observable<JanelaAtualizacaoInformacoes> {
        if (!this.formJanelaAtualizacaoInfo) {
            this.formJanelaAtualizacaoInfo = this.form();
        }

        return this.route.params.pipe(
          mergeMap((params) => {
            if (params['id']) {
              return this.janelasAtualizacaoInfoService.findById(params['id']);
            } else {
              const novo: JanelaAtualizacaoInformacoes = this.janelasAtualizacaoInfoService.getNewEntity();
              return of(novo);
            }
          })
        );
      }

      public salvar(): void {
        this.antesDeSalvar();
        const cadastro = (this.formJanelaAtualizacaoInfo.value as JanelaAtualizacaoInformacoes)

        this.model.dataBase = cadastro.dataBase;
        this.model.dataAbertura = cadastro.dataAbertura;
        this.model.dataFechamento = cadastro.dataFechamento;
        this.model.dataInicioListagemOperacoes = cadastro.dataInicioListagemOperacoes;
        this.model.dataFimListagemOperacoes = cadastro.dataFimListagemOperacoes;
        this.model.tipoJanela = cadastro.tipoJanela;
        this.model.modalidadeGarantia = cadastro.modalidadeGarantia;

        this.ocorrencias = [];
        this.removerAlertasService.removerTodos();
        this.janelasAtualizacaoInfoService['save'](this.getModel()).subscribe(
            (janelaSalva) => {
                this.model = janelaSalva;
                this.aposSalvar();
            },
            (error) => {
                console.log(error);
                this.ocorrencias = this.janelasAtualizacaoInfoService.ocorrencias;
        });
    }

    public editar() {
        this.modoEdicao = true;
        this.trataAlteracaoModoEdicao();
    }

    public habilitarProcessamento() {
        this.janelasAtualizacaoInfoService.habilitarProcessamento(this.model.id).subscribe((obj) => {
            this.setModel(obj);
            this.alteraForm(this.model);
        });
    }

    public desabilitarProcessamento() {
        this.janelasAtualizacaoInfoService.desabilitarProcessamento(this.model.id).subscribe((obj) => {
            this.setModel(obj);
            this.alteraForm(this.model);
        });
    }

    public voltarOuCancelar() {
        if (this.modoEdicao && this.model.id) {
            this.preparaTela().subscribe((obj) => {
                this.setModel(obj);
                this.alteraForm(this.model);
                this.modoEdicao = false;
                this.trataAlteracaoModoEdicao();
            });
        }
        else {
            this.voltarParaLista();
        }
    }

    public aposSalvar(): void {
        this.exibeMensagemSucesso();
        this.modoEdicao = false;
        this.formJanelaAtualizacaoInfo.markAsPristine();
        this.formJanelaAtualizacaoInfo.disable();
    }

    private exibeMensagemSucesso(): void {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Janela de atualização criada/atualizada com sucesso.'
        });
    }

    private async verificaSePodeSair(): Promise<boolean> {
        const titulo = 'Confirmação';
        const mensagem = this.model.id!=null ? 'Descartar alterações realizadas na janela de atualização?' : 'Descartar nova janela de atualização ?';
        
        try {
            const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
            return resultadoConfimacao.value === 'ok';
        } catch (e) {
            return false;
        }
    }

    public canDeactivate(): Promise<boolean> | boolean {
        if (!this.modoEdicao || this.formJanelaAtualizacaoInfo.pristine) 
            return true;
        
        return this.verificaSePodeSair();
    }
}